export default "__VITE_ASSET__CMl1W9a1__"